import { useContext, useEffect, useMemo } from 'react';
import { KlartextEventConfigContext } from '../providers/klartextEventConfig';
import { useKpiCollection } from '../hooks/useKpiCollection';
import ListeningView from './ListeningView';
import { KeywordsSpacyKpiPoint, KeywordsSpacyKpiValue } from '@configTypes/kpiKeywordsSpacy';
import { useGlobalState } from '../providers/globalState';

export function KeywordsView() {
  const globalState = useGlobalState();
  const { dispatch } = globalState ?? {};
  const speechConfig = useContext(KlartextEventConfigContext);
  const [keywordsKpiDemocrat, loadingDemocrat] = useKpiCollection<KeywordsSpacyKpiPoint[]>({
    eventId: speechConfig?.eventId ?? null,
    kpiName: `KeywordsSpacy_${speechConfig?.frontendSpecificConfig?.participants.democrat.transcriptAlias}`,
    initialState: [] as KeywordsSpacyKpiPoint[],
  });

  const [keywordsKpiRepublican, loadingRepublican] = useKpiCollection<KeywordsSpacyKpiPoint[]>({
    eventId: speechConfig?.eventId ?? null,
    kpiName: `KeywordsSpacy_${speechConfig?.frontendSpecificConfig?.participants.republican.transcriptAlias}`,
    initialState: [] as KeywordsSpacyKpiPoint[],
  });

  const keywords = useMemo(() => {
    const latestKeywordKpi = keywordsKpiDemocrat[keywordsKpiDemocrat.length - 1];
    return (
      latestKeywordKpi?.value
        .sort((a: KeywordsSpacyKpiValue, b: KeywordsSpacyKpiValue) => b.occurrences - a.occurrences)
        .slice(0, 20) ?? []
    );
  }, [keywordsKpiDemocrat]) as KeywordsSpacyKpiValue[];

  const keywordsRepublican = useMemo(() => {
    const latestKeywordKpi = keywordsKpiRepublican[keywordsKpiRepublican.length - 1];
    return (
      latestKeywordKpi?.value
        .sort((a: KeywordsSpacyKpiValue, b: KeywordsSpacyKpiValue) => b.occurrences - a.occurrences)
        .slice(0, 20) ?? []
    );
  }, [keywordsKpiRepublican]) as KeywordsSpacyKpiValue[];

  useEffect(() => {
    if (keywords.length === 0) return;
    const mainKeyword = keywords.reduce(
      (acc, keyword) => (keyword.occurrences > acc.occurrences ? keyword : acc),
      keywords[0],
    );
    // dispatch?.({ type: 'SET_MAIN_KEYWORD', payload: mainKeyword.keyword ?? '' });
  }, [keywords]);

  useEffect(() => {
    if (keywordsRepublican.length === 0) return;
    const mainKeyword = keywordsRepublican.reduce(
      (acc, keyword) => (keyword.occurrences > acc.occurrences ? keyword : acc),
      keywordsRepublican[0],
    );
    // dispatch?.({ type: 'SET_MAIN_KEYWORD', payload: mainKeyword.keyword ?? '' });
  }, [keywordsRepublican]);

  if (keywordsKpiDemocrat.length === 0 || loadingDemocrat || speechConfig === null) {
    return <></>;
  }

  return (
    <div className="mt-10 flex justify-between pr-2">
      <div className="flex w-1/2 flex-wrap content-start gap-6">
        {keywords.map((keyword, i) => (
          <Statement contents={keyword} key={i} index={i} party="democrat" />
        ))}
      </div>
      <div className="flex w-1/2 flex-wrap content-start justify-end gap-6">
        {keywordsRepublican.map((keyword, i) => (
          <Statement contents={keyword} key={i} index={i} party="republican" />
        ))}
      </div>
    </div>
  );
}

const Statement = ({ contents, party }: { contents: KeywordsSpacyKpiValue; index: number; party: string }) => {
  return (
    <div
      className={`relative rounded-[1.875rem] bg-eidraWhite px-5 py-2 ${party === 'democrat' ? 'text-democrat' : 'text-republican'}`}>
      <strong className="text-[1.875rem]">{contents.keyword}</strong>
      <span
        className={`absolute right-0 top-0 flex aspect-square h-8 -translate-y-1/2 translate-x-1/4 items-center justify-center rounded-full border-2 border-eidraWhite bg-eidraCream font-medium`}>
        {contents.occurrences}
      </span>
    </div>
  );
};
